import React from "react";
import { Link } from "react-router-dom";

import * as CHQ from "chq";

export const getUserClaimedPath = (feedItem: CHQ.UserActivity) => `/users_claimed/${feedItem.id}`;

type UserActivityClaimedLinkProps = Omit<React.ComponentProps<typeof Link>, "to"> & {
  children: React.ReactNode;
  feedItem: CHQ.UserActivity;
};

const UserActivityClaimedLink: React.FC<UserActivityClaimedLinkProps> = (
  { children, feedItem, tabIndex, ...props }
) => (
  <Link {...props} to={getUserClaimedPath(feedItem)} tabIndex={tabIndex || 0}>
    {children}
  </Link>
);

export default UserActivityClaimedLink;
